import { Link } from "react-router-dom";
import { Eye } from "lucide-react";
import CommunityShare from "@/components/CommunityShare";

export default function Footer() {
  return (
    <footer className="relative bg-onyx border-t border-white/10 grain overflow-hidden" data-testid="footer">
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-24 md:py-32">
        <div className="max-w-3xl">
          <p className="text-xs uppercase tracking-[0.3em] text-gold mb-6">Knowledge · Wisdom · Overstanding</p>
          <h2 className="font-serif text-4xl md:text-6xl leading-tight text-bone mb-8">
            Reclaim the sacred knowledge of your ancestors.
          </h2>
          <Link to="/videos" className="inline-block bg-gold text-black px-10 py-3 font-medium hover:bg-gold2 transition-colors" data-testid="footer-cta">
            Begin Your Journey
          </Link>
        </div>

        <div className="mt-20 grid grid-cols-2 md:grid-cols-4 gap-10 text-sm">
          <div>
            <div className="flex items-center gap-2 mb-4"><Eye className="text-gold" size={20} strokeWidth={1.5} /><span className="font-serif text-xl">Apocalypz.org</span></div>
            <p className="text-bone/50 leading-relaxed">A digital sanctuary for Africa and her Diaspora — esoteric, spiritual, scientific and metaphysical knowledge.</p>
          </div>
          <div>
            <p className="text-gold uppercase tracking-widest text-xs mb-4">Explore</p>
            <ul className="space-y-2 text-bone/60">
              <li><Link to="/videos" className="hover:text-gold">Video Library</Link></li>
              <li><Link to="/classes" className="hover:text-gold">Classes</Link></li>
              <li><Link to="/library" className="hover:text-gold">Downloads</Link></li>
              <li><Link to="/store" className="hover:text-gold">Store</Link></li>
            </ul>
          </div>
          <div>
            <p className="text-gold uppercase tracking-widest text-xs mb-4">Teachings</p>
            <ul className="space-y-2 text-bone/60">
              <li>Nuwaupian Nation</li>
              <li>Nation of Islam</li>
              <li>Moorish Science</li>
              <li>Hebrew Israelites</li>
              <li>Kemetic Mysteries</li>
            </ul>
          </div>
          <div>
            <p className="text-gold uppercase tracking-widest text-xs mb-4">Masters</p>
            <ul className="space-y-2 text-bone/60">
              <li>Dr. Malachi Z. York</li>
              <li>Marcus Garvey</li>
              <li>Bobby Hemmitt</li>
              <li>Phil Valentine</li>
              <li>Noble Drew Ali</li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-12 border-t border-white/10">
          <CommunityShare />
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between text-bone/40 text-xs gap-2">
          <span>© 2026 Apocalypz.org — For the upliftment of Africa and the Diaspora.</span>
          <span>Preserving ancestral knowledge for the awakening generation.</span>
        </div>
      </div>
    </footer>
  );
}
